import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import {
	StyledTab,
	StyledTabText,
} from '@dealstack/frontend/shared/components/MantineTabs/styled.tsx';
import { Badge } from '@mantine/core';
import type { MantineTabProps } from './MantineTab.types';

export const MantineTab = <T extends string>({
	label,
	value,
	count,
	icon,
	testId,
	...tabProps
}: MantineTabProps<T>) => {
	return (
		<StyledTab
			data-testid={testId}
			value={value}
			px="0.5rem"
			h="100%"
			leftSection={icon ? <Icon variant={icon} size="lg" /> : undefined}
			rightSection={
				count !== undefined ? (
					<Badge size="xs" p="0.25rem" fw={400} c="dark.4" bg="gray.4">
						{count}
					</Badge>
				) : null
			}
			{...tabProps}
		>
			<StyledTabText size="md" c="dark.9" lineClamp={1} data-label={label}>
				{label}
			</StyledTabText>
		</StyledTab>
	);
};
